import PropTypes from "prop-types";
import styled from "theme/libs/styled";

/**
 * Used by the module system.
 * Add a consistent margin bottom that will be the same across the site.
 * @param {string} marginAfter - Choose a predefined margin to use.
 */

const ModuleMarginWrapper = styled("div", {
    shouldForwardProp: (prop) => ["marginAfter"].indexOf(prop) === -1,
})`
    ${({ theme, marginAfter }) => {
        // Style for marginAfter = lg
        if (marginAfter === "lg") {
            return `
                margin: 64px 0;

                ${theme.above.desktopSm} {
                    margin: 96px 0;
                }
            `;
            // Style for marginAfter = md (Default)
        } else if (marginAfter === "md") {
            return `
                margin: 6px 0;

                ${theme.above.desktopSm} {
                    margin: 8px 0;
                }
            `;
            // Style for marginAfter = sm
        } else if (marginAfter === "sm") {
            return `
                margin-bottom: 12px;

                ${theme.above.desktopSm} {
                    margin-bottom: 48px;
                }
            `;

            // Style for marginAfter = xs
        } else if (marginAfter === "xs") {
            return `
                margin-bottom: 12px;

                ${theme.above.tabletSm} {
                    margin-bottom: 16px;
                }
            `;

            // Style for marginAfter = none
        } else if (marginAfter === "none") {
            return null;
        }
    }}
`;

export const marginAfterProps = PropTypes.oneOf(["none", "xs", "sm", "md"]);

ModuleMarginWrapper.propTypes = {
    marginAfter: marginAfterProps,
};

ModuleMarginWrapper.defaultProps = {
    marginAfter: "md",
};

export default ModuleMarginWrapper;
